const customise = {
  NAVIGATION_ITEMS: [
    { name: 'variant' },
    { name: 'colour' },
    { name: 'interior' },
    { name: 'options' },
    { name: 'accessories' },
    { name: 'service' },
    { name: 'summary' },
  ],
  COMPLEX_NAVIGATION_ITEMS: [{ name: 'exterior' }, { name: 'interior' }, { name: 'options' }, { name: 'summary' }],
  STOCK_ITEM: { name: 'stock' },
  DOM_ID_PREFIX: 'customise_',
  NAVIGATION_BAR_ID: 'dxpSpcCustomiseNavigationBar',
};

export default customise;
